<template>
<!-- Fragements... -->
  <div class="mobile-side-panel">
    <div class="side-panel" :class="{open}">
      <i class="c-icon icon-times-regular close" @click="$emit('close')"></i>
      <Nav :items="header.items" orientation="vertical"/>
    </div>
  </div>
</template>

<script>

/* Todo 
  add Styling settings 
  - Add styling optins
  - Add mobile menu
  - Extend mobile order options, only option is now: mobile-layout-one
*/

import Nav from './Nav.vue'

export default {
  components: { Nav },
  props: {
    open: Boolean,
    header: {
      type: Object,
      default:() => ({})
    }
  }
}

</script>

<style lang="scss">

@keyframes navFadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.side-panel {
  width: 100%;
  height: 100%;
  padding: 16px;
  background: white;
  position: fixed;
  opacity: 0;
  top:0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transition: opacity 400ms cubic-bezier(.4,0,.2,1);
  pointer-events: none;
  font-size: 14px;

  a {
    cursor: pointer;
  }

  .navigation {
    margin-top: 50px;
  }

  .close {
    font-size: 25px;
    text-align: right;
  }

}


.side-panel.open {
  pointer-events: all;
  opacity: 1;

  .navigation li {
    will-change: opacity;
    animation: navFadeIn;
    animation-duration: 1s;
    animation-fill-mode: both;
    $total-items: 20;

    @for $i from 1 through $total-items {
      &:nth-child(#{$i}) {
        animation-delay: .25s * $i;
      }
    }
  }

}

</style>